const menuService = {
    getMenu: (menuName) => {
        return Collaterate.Site.getMenuByName(menuName)
    }
};

export default menuService;